let ServiceTagType = /*#__PURE__*/function (ServiceTagType) {
  ServiceTagType["NEW_SERVICE"] = "NEW_SERVICE";
  ServiceTagType["NEW_PRICE"] = "NEW_PRICE";
  ServiceTagType["PROMOTION"] = "PROMOTION";
  ServiceTagType["RECOMMENDED"] = "RECOMMENDED";
  ServiceTagType["ECO_FRIENDLY"] = "ECO_FRIENDLY";
  ServiceTagType["POPULAR"] = "POPULAR";
  ServiceTagType["EXCLUSIVE_FOR_PLUS"] = "EXCLUSIVE_FOR_PLUS";
  return ServiceTagType;
}({});
let ServiceCategory = /*#__PURE__*/function (ServiceCategory) {
  ServiceCategory["ECONOMY"] = "economy";
  ServiceCategory["EXPRESS"] = "express";
  ServiceCategory["STANDARD"] = "standard";
  return ServiceCategory;
}({});

export { ServiceCategory, ServiceTagType };
//# sourceMappingURL=Service.js.map
